export let MessageTypes;
(function (MessageTypes) {
  MessageTypes["MSG_TYPE_FLOW_START"] = "FLOW_START";
  MessageTypes["MSG_TYPE_HIDE_MODAL"] = "HIDE_MODAL";
  MessageTypes["MSG_TYPE_MODAL_HIDDEN"] = "MODAL_HIDDEN";
  MessageTypes["MSG_TYPE_ADD_ALERT"] = "ADD_ALERT";
  MessageTypes["MSG_TYPE_APP_READY"] = "MSG_TYPE_APP_READY";
})(MessageTypes || (MessageTypes = {}));